// @flow

import * as React from 'react';

import { NavigableListItem } from '@ta/list.navigable-list';
import { localize } from '@ta/common.i18n';

import type { FetcherResult } from '../Typeahead';

import BasicResult from './BasicResult';
import TypeaheadTracking, { type UserInteractionType } from '../TypeaheadTracking';
import type { TypeaheadResult } from '../TypeaheadResult';

type Props = {|
  /** The TypeaheadJsonFetcher result */
  result: FetcherResult,

  /** The typeahead tracker */
  tracker: TypeaheadTracking,

  /** An optional callback if a result is selected */
  onSelection?: (
    event: SyntheticEvent<HTMLElement> | KeyboardEvent,
    result: TypeaheadResult,
  ) => void,

  /** An optional callback for if/when the mouse moves over the result */
  onMouseMove?: (event: SyntheticMouseEvent<HTMLElement>) => mixed,

  /** True if this result is active. Defaults to false */
  active?: boolean,

  /** result position in result list */
  resultIndex?: number,
|};

/**
 * Create a rescue typeahead search result from /TypeaheadJson?action=API. Selecting a result of this type will trigger a
 * call to onSelection() with a TypeaheadResult of { type: "rescue", value: <url> }
 *
 * Note that this is intended to be used inside a <NavigableList/>
 */

class RescueResult extends React.Component<Props> {
  static defaultProps = {
    onSelection: undefined,
    onMouseMove: undefined,
    active: false,
    resultIndex: undefined,
  };

  onSelect = (event: SyntheticEvent<HTMLElement> | KeyboardEvent) => {
    const userInteractionType: UserInteractionType = event.type === 'click' ? 'click' : 'enter';
    const { tracker, onSelection, result, resultIndex } = this.props;

    // ETL Track the select event
    const trackingData = { resultIndex, ...result };
    tracker.trackSelection(trackingData, userInteractionType);
    // ETL Track the search event
    tracker.trackEventViaMEVTCookie(trackingData, userInteractionType);

    if (onSelection) {
      onSelection(event, {
        type: 'rescue',
        value: result.url, // url: /Search?q=<query>
      });
    }
  };

  render() {
    const name: string = `${localize('typeAheadSearchFor_fffff81b', {
      '0': this.props.result.query,
    })}`;
    const isRescue: boolean = true;

    return (
      <NavigableListItem
        onSelection={this.onSelect}
        onMouseMove={this.props.onMouseMove}
        active={this.props.active}
      >
        <BasicResult
          title={name}
          active={this.props.active}
          iconName="search"
          isRescue={isRescue}
        />
      </NavigableListItem>
    );
  }
}

export default RescueResult;
